module.exports = __webpack_public_path__ + "img/shopSelet.5db4a026.png";